export const SET_IS_LOADING = 'SET_IS_LOADING';

export const SET_TRANSACTIONS = 'SET_TRANSACTIONS';
